<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div
  id="billing-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="billing-modal-title"
  class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
  <div
    class="bg-white w-full max-w-md rounded-xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
    <div class="p-6 border-b border-gray-100 flex justify-between items-center">
      <h3 id="billing-modal-title" class="font-spartan text-xl font-bold text-[#1E2952]">
        Update Payment Method
      </h3>
      <button
        type="button"
        (click)="onCancel()"
        class="text-gray-400 hover:text-gray-600 focus:outline-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          data-lucide="x"
          aria-hidden="true"
          class="lucide lucide-x w-6 h-6">
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      </button>
    </div>

    <form class="p-6 space-y-4" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (submitError()) {
        <div
          class="bg-red-50 border border-red-200 text-[#D32F2F] px-4 py-3 rounded-lg text-sm flex items-start gap-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            data-lucide="alert-circle"
            aria-hidden="true"
            class="lucide lucide-alert-circle w-5 h-5 shrink-0 mt-0.5">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" x2="12" y1="8" y2="12"></line>
            <line x1="12" x2="12.01" y1="16" y2="16"></line>
          </svg>
          <div>
            <p class="font-bold">Update Failed</p>
            <p class="text-[12px] mt-0.5 text-[#D32F2F]/80">{{ submitError() }}</p>
          </div>
        </div>
      }

      <div class="space-y-1.5">
        <label class="block text-[13px] font-bold text-[#1E2952]">Cardholder Name</label>
        <input
          type="text"
          formControlName="cardholderName"
          class="block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm outline-none focus:ring-2 focus:ring-[#0084C4]"
          placeholder="" />
      </div>

      <div class="space-y-1.5">
        <label class="block text-[13px] font-bold text-[#1E2952]">Card Number</label>
        <div class="relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              data-lucide="credit-card"
              aria-hidden="true"
              class="lucide lucide-credit-card w-4 h-4 text-gray-400">
              <rect width="20" height="14" x="2" y="5" rx="2"></rect>
              <line x1="2" x2="22" y1="10" y2="10"></line>
            </svg>
          </div>
          <div
            #cardNumberElement
            class="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg text-sm outline-none focus:ring-2 focus:ring-[#0084C4]"></div>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div class="space-y-1.5">
          <label class="block text-[13px] font-bold text-[#1E2952]">Expiry Date</label>
          <div
            #cardExpiryElement
            class="block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm outline-none focus:ring-2 focus:ring-[#0084C4]"></div>
        </div>
        <div class="space-y-1.5">
          <label class="block text-[13px] font-bold text-[#1E2952]">CVC</label>
          <div
            #cardCvcElement
            class="block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm outline-none focus:ring-2 focus:ring-[#0084C4]"></div>
        </div>
      </div>

      <div class="flex items-center gap-2 pt-2 text-[12px] text-gray-500 bg-gray-50 p-3 rounded-lg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          data-lucide="shield-check"
          aria-hidden="true"
          class="lucide lucide-shield-check w-4 h-4 text-[#2E7D32]">
          <path
            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
          <path d="m9 12 2 2 4-4"></path>
        </svg>
        Your payment information is stored securely.
      </div>

      <div class="pt-4 flex gap-3">
        <button
          type="button"
          (click)="onCancel()"
          class="flex-1 px-4 py-2.5 border border-gray-200 text-gray-600 font-bold rounded-lg hover:bg-gray-50 transition-colors text-sm"
          [disabled]="isSubmitting()">
          Cancel
        </button>
        <button
          type="submit"
          class="flex-1 px-4 py-2.5 bg-[#0084C4] text-white font-bold rounded-lg hover:bg-[#006A9D] transition-colors text-sm shadow-md disabled:opacity-60 disabled:cursor-not-allowed"
          [disabled]="!form.valid || !isCardValid() || isSubmitting()">
          {{ isSubmitting() ? 'Saving...' : 'Save Changes' }}
        </button>
      </div>
    </form>
  </div>
</div>
